import { forwardRef } from "react";
import classNames from "classnames/bind";
import { Card, CardProps } from "../Card/Card";
import { Link, LinkProps } from "../Link/Link";
import styles from "./CardLink.module.scss";

const cx = classNames.bind(styles);

export type CardLinkProps = Pick<CardProps, "variant" | "orientation" | "padding" | "gap"> &
	LinkProps;

/** Clickable Card rendered as a single Link over the whole surface (hover/focus included). */
export const CardLink = forwardRef<HTMLAnchorElement, CardLinkProps>(
	({ variant, orientation, padding, gap, className, children, ...linkProps }, ref) => (
		<Card asChild variant={variant} orientation={orientation} padding={padding} gap={gap}>
			<Link
				ref={ref}
				className={cx(
					"card-link",
					{ "card-link--hover-shadow": variant !== "elevated" },
					className
				)}
				{...linkProps}
			>
				{children}
			</Link>
		</Card>
	)
);

CardLink.displayName = "CardLink";
